import React, { useState } from "react";

const VIMEO_EMBED =
  "https://player.vimeo.com/video/660606209?h=6019503020&title=0&byline=0&portrait=0&badge=0&dnt=1&loop=1";

/**
 * Click-to-load Vimeo embed by default; supports muted autoplay for compact panels.
 */
export default function HomeIntroVideo({
  autoPlay = false,
  buttonLabel = "Play introduction video",
  ariaLabel = "Play Plux Infosystems introduction video",
  title = "Plux Infosystems introduction video on Vimeo",
}) {
  const [active, setActive] = useState(autoPlay);
  const videoSrc = autoPlay
    ? `${VIMEO_EMBED}&autoplay=1&muted=1`
    : VIMEO_EMBED;

  if (!active) {
    return (
      <button
        type="button"
        className="home-intro-video__activate"
        onClick={() => setActive(true)}
        aria-label={ariaLabel}
      >
        <span className="home-intro-video__play" aria-hidden="true">
          ▶
        </span>
        <span className="home-intro-video__label">{buttonLabel}</span>
      </button>
    );
  }

  return (
    <iframe
      title={title}
      src={videoSrc}
      className="home_iframe home-intro-video__iframe"
      width="620"
      height="360"
      frameBorder="0"
      allow="autoplay; fullscreen; picture-in-picture"
      allowFullScreen
      loading={autoPlay ? "eager" : "lazy"}
    />
  );
}
